import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { IBenefitGroup, IBenefitOption } from '../../../../shared/models/bills.interface';

@Component({
  selector: 'app-bill-package-content',
  standalone: true,
  imports: [NgClass, MatIcon, MatIconButton],
  templateUrl: './bill-package-content.component.html',
  styleUrl: './bill-package-content.component.scss',
})
export class BillPackageContentComponent {
  @Input() isReadOnly = false;
  @Input() benefitGroups: IBenefitGroup[] = [];

  @Output() benefitSelectionChange = new EventEmitter<IBenefitGroup[]>();

  // Id of the group whose benefit-level dropdown is currently open (null = none).
  openGroupId: string | null = null;

  toggleDropdown(group: IBenefitGroup, event: Event): void {
    // Stop the document:click handler below from closing it on the same click.
    event.stopPropagation();
    this.openGroupId = this.openGroupId === group.benefitTypeId ? null : group.benefitTypeId;
  }

  onOptionChange(group: IBenefitGroup, option: IBenefitOption): void {
    group.selectedOption = option;
    this.openGroupId = null;
    this.benefitSelectionChange.emit(this.benefitGroups);
  }

  // Close the open dropdown when clicking anywhere else on the page.
  @HostListener('document:click')
  onDocumentClick(): void {
    this.openGroupId = null;
  }
}
